export const envConfig = {
  publicUrl: `${process.env.PUBLIC_URL}`,
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  legacyUrl: `${process.env.REACT_APP_LEGACY_URL}`,
  useLegacyLogin: `${process.env.REACT_APP_USE_LEGACY_LOGIN}` === 'true',
  enableDevLinks: `${process.env.REACT_APP_ENABLE_DEV_LINKS}` === 'true',
  reCaptchaKey: `${process.env.REACT_APP_RECAPTCHA_KEY}`,
  reCaptchaV2Key: `${process.env.REACT_APP_RECAPTCHA_V2_KEY}`,
  azureClientId: process.env.REACT_APP_AZURE_CLIENT_ID,
  reactAppPublicUrl: process.env.REACT_APP_PUBLIC_URL,
};
